import logo from "../assets/logo.svg"
import { Link } from "react-router-dom"

const AppLogo = () => {
  return (
    <Link to="/">
      <img src={logo} alt="ShopMuchMore Logo" className="h-10 w-[133px]" width="133" height="40" />
    </Link>
  )
}

export default AppLogo